namespace Solovis.Properties.ResourcePropertiesEditor {

    export function showDialog(container) {
        var desiredWidth = Math.min($(window).width() * .8, 650);
        var desiredHeight = Math.min($(window).height() * .8, 500);

        var minWidth = 100;
        var minHeight = 100;

        var dialog = new Solovis.UI.Dialog({
            container: container,

            title: "Properties",
            center: true,
            width: desiredWidth,
            minWidth: minWidth,
            minHeight: minHeight,
            height: desiredHeight,
            autoOpen: true,
            modal: true,
            destroyOnClose: true,
            actions: ["Close"]
        });

        return dialog;
    }

    export function showPropertyListDialog(options) {
        Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.PropertyEditor"], function () {
            var resourceId = options.resourceId ? options.resourceId : null;
            var txId = options.txId ? options.txId : null;
            var entityId = options.entityId ? options.entityId : null;
            var investmentId = options.investmentId ? options.investmentId : null;

            var resourcePropertiesReportDiv = $("<div>");

            var resourcePropertiesReportControl = new (Solovis as any).Properties.Editors.ResourcePropertiesEditorControl({
                resourceId: resourceId,
                txId: txId,
                entityId: entityId,
                investmentId: investmentId,
                controlHost: resourcePropertiesReportDiv
            });

            resourcePropertiesReportControl.setAsCurrentControl();

            var dialog = showDialog(resourcePropertiesReportDiv);
        });
    }
}
